import { useEffect, useState } from "react";

import AdminPage from "./components/AdminPage";
import StatCard from "./components/StatCard";
import AdminCard from "./components/AdminCard";

import { FaUsers, FaMoneyBillWave, FaCrown, FaChartLine } from "react-icons/fa";

import { getDashboardStats } from "./api/dashboardApi";

export default function Dashboard() {
  const [stats, setStats] = useState({
    totalUsers: 0,
    activeSubscriptions: 0,
    totalRevenue: 0,
    todayBets: 0,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  async function loadStats() {
    try {
      const data = await getDashboardStats();

      setStats(data);
    } catch (error) {
      console.error("Error loading dashboard stats:", error);
    } finally {
      setLoading(false);
    }
  }

  const cards = [
    {
      title: "Users",
      value: stats.totalUsers,
      icon: <FaUsers />,
    },
    {
      title: "Subscriptions",
      value: stats.activeSubscriptions,
      icon: <FaCrown />,
    },
    {
      title: "Revenue",
      value: `$${Number(stats.totalRevenue).toFixed(2)}`,
      icon: <FaMoneyBillWave />,
    },
    {
      title: "Today's Bets",
      value: stats.todayBets,
      icon: <FaChartLine />,
    },
  ];

  return (
    <AdminPage
      title='Dashboard'
      subtitle='Manage your application from one place.'
    >
      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6'>
        {cards.map((card) => (
          <StatCard
            key={card.title}
            title={card.title}
            value={loading ? "..." : card.value}
            icon={card.icon}
          />
        ))}
      </div>

      <AdminCard className='mt-8 p-6'>
        <h2 className='text-2xl font-bold text-green-300 mb-4'>
          Recent Activity
        </h2>
      </AdminCard>
    </AdminPage>
  );
}
